import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import Admin from '@/views/Admin'
import Amendments from '@/views/Amendments'
import Claims from '@/views/Claims'
import Contract from '@/views/Contract.vue'
import ContractMain from '@/views/ContractMain.vue'
import Contracts from '@/views/Contracts.vue'
import DemoPage from '@/views/DemoPage'
import EarlyWarnings from '@/views/EarlyWarnings'
import Guarantees from '@/views/Guarantees'
import Insights from '@/views/Insights'
import LiquidatedDamages from '@/views/LiquidatedDamages'
import PaymentMilestones from '@/views/PaymentMilestones'
import Payments from '@/views/Payments.vue'
import PaymentsApplications from '@/views/PaymentsApplications'
import Report from '@/views/Report'
import Reports from '@/views/Reports'
import ReportsMain from '@/views/ReportsMain'
import Variations from '@/views/Variations'

import InsightsClaimsView from '@/views/InsightsClaimsView.vue'
import InsightsOverview from '@/views/InsightsOverview.vue'
import InsightsVariationsView from '@/views/InsightsVariationsView.vue'
import InsightsLiquidatedDamagesView from '@/views/InsightsLiquidatedDamagesView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'contracts',
    show: true,
    meta: {
      displayName: 'Contracts',
      icon: 'mdi-file-document-multiple-outline'
    },
    component: Contracts
  },
  {
    path: '/contracts/new',
    name: 'new contract',
    show: false,
    meta: {
      displayName: 'Create Contract',
      icon: 'mdi-file-find-outline'
    },
    component: Contract
  },
  {
    path: '/contracts/:contractId',
    name: 'contractMain',
    show: true,
    meta: {
      displayName: 'Contract Details',
      icon: 'mdi-file-find-outline'
    },
    component: ContractMain,
    children: [
      {
        path: '',
        name: 'contract',
        show: true,
        showForParent: true,
        meta: {
          displayName: 'Contract Details',
          icon: 'mdi-file-find-outline'
        },
        component: Contract
      },
      {
        path: '/contracts/:contractId/payments',
        name: 'payments',
        show: true,
        showForParent: false,
        meta: {
          displayName: 'Payments',
          icon: 'mdi-cash-multiple'
        },
        component: Payments,
        children: [
          {
            path: '/contracts/:contractId/payments/schedule',
            name: 'schedule',
            show: true,
            meta: {
              displayName: 'Schedule',
              icon: 'mdi-cash-multiple'
            },
            component: PaymentMilestones
          },
          {
            path: '/contracts/:contractId/payments/applications',
            name: 'applications',
            show: true,
            meta: {
              displayName: 'Applications',
              icon: 'mdi-cash-multiple'
            },
            component: PaymentsApplications
          }
        ]
      },
      {
        path: '/contracts/:contractId/variations',
        name: 'variations',
        show: true,
        showForParent: false,
        meta: {
          displayName: 'Variations',
          icon: 'mdi-file-swap-outline'
        },
        component: Variations
      },
      {
        path: '/contracts/:contractId/claims',
        name: 'claims',
        show: true,
        showForParent: false,
        meta: {
          displayName: 'Claims',
          icon: 'mdi-file-plus-outline'
        },
        component: Claims
      },
      {
        path: '/contracts/:contractId/amendments',
        name: 'amendments',
        show: true,
        meta: {
          displayName: 'Amendments',
          icon: 'mdi-file-plus-outline'
        },
        component: Amendments
      },
      {
        path: '/contracts/:contractId/early-warnings',
        name: 'early_warnings',
        show: true,
        meta: {
          displayName: 'Early Warnings',
          icon: 'mdi-file-plus-outline'
        },
        component: EarlyWarnings
      },
      {
        path: '/contracts/:contractId/guarantees',
        name: 'guarantees',
        show: true,
        showForParent: false,
        meta: {
          displayName: 'Guarantees',
          icon: 'mdi-shield-outline'
        },
        component: Guarantees
      },
      {
        path: '/contracts/:contractId/lds',
        name: 'lds',
        show: true,
        showForParent: false,
        meta: {
          displayName: 'LDs',
          icon: 'mdi-file-table-outline'
        },
        component: LiquidatedDamages
      },
      {
        path: '/contracts/:contractId/reports',
        name: 'reportsMain',
        show: true,
        showForParent: false,
        meta: {
          displayName: 'Reports',
          icon: 'mdi-file-table-outline'
        },
        component: ReportsMain,
        children: [
          {
            path: '',
            name: 'reports',
            show: true,
            showForParent: false,
            meta: {
              displayName: 'Reports',
              icon: 'mdi-file-table-outline'
            },
            component: Reports
          },
          {
            path: '/contracts/:contractId/reports/:reportId',
            name: 'report',
            show: false,
            showForParent: false,
            meta: {
              displayName: 'Report',
              icon: 'mdi-file-table-outline'
            },
            component: Report
          }
        ]
      }
    ]
  },
  {
    path: '/demo',
    name: 'demo',
    show: false,
    meta: {
      displayName: 'DemoPage',
      icon: 'mdi-square-outline'
    },
    component: DemoPage
  },
  {
    path: '/insights',
    name: 'insights',
    show: true,
    meta: {
      displayName: 'Insights',
      icon: 'mdi-square-outline'
    },
    component: Insights,
    children: [
      {
        path: 'overview',
        name: 'InsightsOverview',
        show: true,
        meta: {
          displayName: 'Overview',
          icon: 'mdi-square-outline'
        },
        component: InsightsOverview
      },
      {
        path: 'claims',
        name: 'InsightsClaimsView',
        show: true,
        meta: {
          displayName: 'Claims',
          icon: 'mdi-square-outline'
        },
        component: InsightsClaimsView
      },
      {
        path: 'variations',
        name: 'InsightsVariationsView',
        show: true,
        meta: {
          displayName: 'Variations',
          icon: 'mdi-square-outline'
        },
        component: InsightsVariationsView
      },
      {
        path: 'lds',
        name: 'InsightsLiquidatedDamagesView',
        show: true,
        meta: {
          displayName: 'LDs',
          icon: 'mdi-square-outline'
        },
        component: InsightsLiquidatedDamagesView
      }
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    show: true,
    meta: {
      displayName: 'Admin',
      icon: 'mdi-square-outline'
    },
    component: Admin
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.path.startsWith('/insights'))) {
    const { isInsightsViewer } = store.state
    if (!isInsightsViewer) {
      return next({ name: 'contracts' })
    }
  }
  if (to.matched.some(record => record.path.startsWith('/admin'))) {
    const { isAdmin, isAreaManager } = store.state
    if (!isAdmin && !isAreaManager) {
      return next({ name: 'contracts' })
    }
  }
  next()
})

export default router
